import React, { useState, useEffect } from "react";
import {
  FaFileCode,
  FaGraduationCap,
  FaHome,
  FaPhoneAlt,
  FaUserAlt,
} from "react-icons/fa";
import "../../assets/style/Home.css";
import "animate.css";
import { useTranslation } from "react-i18next";

const Aside: React.FC = () => {
  const [activeLink, setActiveLink] = useState("accueil");
  const [isTablet, setIsTablet] = useState(
    window.innerWidth > 768 && window.innerWidth <= 1024
  );
  const { t } = useTranslation("fr", { useSuspense: false });

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth > 768 && window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ======= Scroll : toujours actif, aucun blocage =======
  useEffect(() => {
    const handleScroll = () => {
      const sections = ["accueil", "about", "qualification", "skills", "work", "contact"];
      const offset = window.innerWidth > 768 && window.innerWidth <= 1024 ? 80 : 120;

      let current = "accueil";
      for (const id of sections) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= offset) {
          current = id;
        }
      }
      setActiveLink(current);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Clic : juste set l'active, le scroll prendra le relais automatiquement
  const handleClick = (id: string) => {
    setActiveLink(id);
  };

  // ======= Le reste de ton code =======
  return (
    <div>
      <aside className={`sidebar${isTablet ? ' tablet-nav' : ''}`} id="sidebar">
        <nav className="nav">
          <div className="nav__logo">
            <a href="#accueil">
              <span className="nav__logo-text">R</span>
            </a>
          </div>

          <div className="nav__menu">
            <div className="menu">
              <ul className="nav__list">
                <li>
                  <a href="#accueil"
                    className={`nav__link${activeLink === "accueil" ? " active" : ""}`}
                    onClick={() => handleClick("accueil")}
                  >{t("main.home")}</a>
                </li>
                <li>
                  <a href="#about"
                    className={`nav__link${activeLink === "about" ? " active" : ""}`}
                    onClick={() => handleClick("about")}
                  >{t("main.about")}</a>
                </li>
                <li>
                  <a href="#qualification"
                    className={`nav__link${activeLink === "qualification" ? " active" : ""}`}
                    onClick={() => handleClick("qualification")}
                  >{t("main.qualification")}</a>
                </li>
                <li>
                  <a href="#skills"
                    className={`nav__link${activeLink === "skills" ? " active" : ""}`}
                    onClick={() => handleClick("skills")}
                  >{t("main.skills")}</a>
                </li>
                <li>
                  <a href="#contact"
                    className={`nav__link${activeLink === "contact" ? " active" : ""}`}
                    onClick={() => handleClick("contact")}
                  >{t("main.contact")}</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </aside>

      <div>
        <ul className="mobile__list">
          <li className="mobile-nav__item">
            <a href="#accueil"
              className={`mobile-nav__link ${activeLink === "accueil" ? "active" : ""}`}
              onClick={() => handleClick("accueil")}
            >
              <div className="mobile-nav__icon-container">
                <FaHome size={22} />
                <span className="mobile-nav__indicator"></span>
              </div>
              <span className="mobile-nav__label">Accueil</span>
            </a>
          </li>
          <li className="mobile-nav__item">
            <a href="#about"
              className={`mobile-nav__link ${activeLink === "about" ? "active" : ""}`}
              onClick={() => handleClick("about")}
            >
              <div className="mobile-nav__icon-container">
                <FaUserAlt size={20} />
                <span className="mobile-nav__indicator"></span>
              </div>
              <span className="mobile-nav__label">About</span>
            </a>
          </li>
          <li className="mobile-nav__item">
            <a href="#qualification"
              className={`mobile-nav__link ${activeLink === "qualification" ? "active" : ""}`}
              onClick={() => handleClick("qualification")}
            >
              <div className="mobile-nav__icon-container">
                <FaGraduationCap size={22} />
                <span className="mobile-nav__indicator"></span>
              </div>
              <span className="mobile-nav__label">Études</span>
            </a>
          </li>
          <li className="mobile-nav__item">
            <a href="#skills"
              className={`mobile-nav__link ${activeLink === "skills" ? "active" : ""}`}
              onClick={() => handleClick("skills")}
            >
              <div className="mobile-nav__icon-container">
                <FaFileCode size={22} />
                <span className="mobile-nav__indicator"></span>
              </div>
              <span className="mobile-nav__label">Skills</span>
            </a>
          </li>
          <li className="mobile-nav__item">
            <a href="#contact"
              className={`mobile-nav__link ${activeLink === "contact" ? "active" : ""}`}
              onClick={() => handleClick("contact")}
            >
              <div className="mobile-nav__icon-container">
                <FaPhoneAlt size={20} />
                <span className="mobile-nav__indicator"></span>
              </div>
              <span className="mobile-nav__label">Contact</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Aside;
